module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAAdUlEQVR4AWOgD1CYTyQaEA3/weD5u9f3XzyBsAlr+Pv7x6TNC2btWP73z0+iNMxbeLyvoLMzp3vZytPYNVwSMIGjz9+/9C2pyoqUzg6XnLay6euPb8iyWDQ8fP9s+dk1qy5tAaIVZ9c+ev+cgAZMRGcNgxIAACr/t2wQEkSwAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/HT.png
// module id = 1162
// module chunks = 0